import { render, staticRenderFns } from "./ParentsList.vue?vue&type=template&id=f9bfc69a&scoped=true"
import script from "./ParentsList.vue?vue&type=script&lang=js"
export * from "./ParentsList.vue?vue&type=script&lang=js"
import style0 from "./ParentsList.vue?vue&type=style&index=0&id=f9bfc69a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9bfc69a",
  null
  
)

export default component.exports